import axios from 'axios'
import { DateTime } from 'luxon'

const state = {
  menuItemsList: [],
  menuItemsSingle: null,
}

const getters = {
  getMenuItemsList (state) {
    return state.menuItemsList
  },
  getMenuItemsSingle (state) {
    return state.menuItemsSingle
  },
}

const mutations = {
  setMenuItemsList (state, payload) {
    state.menuItemsList = payload
  },
  setMenuItemsSingle (state, payload) {
    state.menuItemsSingle = payload
  },
  clearMenuItemsSingle (state) {
    state.menuItemsSingle = null
  },
}

const actions = {
  fetchMenuItemsList ({ commit, rootGetters }, meta) {
    const url = rootGetters['api/menuItemsList']
    return axios
      .get(
        url, {
          params: meta,
        },
      )
      .then((res) => {
        commit('setMenuItemsList', res.data.items)

        return res
      })
  },
  fetchSingleMenuItems ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/menuItemsSingle'](id))
      .then((res) => {
        commit('setMenuItemsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },

  fetchMenuItemsUpsalesList ({ commit, rootGetters }, meta) {
    const url = rootGetters['api/menuItemsUpsalesList']
    return axios
      .get(
        url, {
          params: meta,
        },
      )
      .then((res) => {
        return res.data.items
      })
  },

  createMenuItems ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/menuItemsCreate'], data)
      .then((res) => {
        return res
      })
  },
  editMenuItems ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/menuItemsEdit'](id), data)
      .then((res) => {
        return res
      })
  },
  deleteMenuItems ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/menuItemsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getMenuItemsList.filter((val) => val.id !== id)
          commit('setMenuItemsList', items)
        }

        return res
      })
      .catch((err) => err)
  },

  downloadExcell ({ rootGetters, dispatch }, meta) {
    meta = meta || {}

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/downloadMenuItemsExcell']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', {
      url,
      source,
    }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
        responseType: 'blob',
      })
      .then(res => {
        // create file link in browser's memory
        const href = URL.createObjectURL(res.data)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a')
        link.href = href
        const dateTime = DateTime.now().toFormat('dd-MM-yyyy-HH-mm-ss')
        const fileName = `fact_menu_items_${dateTime}.xlsx`
        link.setAttribute('download', fileName) // or any other extension
        document.body.appendChild(link)
        link.click()

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return true
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
